import { css } from '@emotion/css';

import { cn } from '@lyearn/style';
import { svgSizeStyles } from '@/utils/styles';

export const menuItemSelectedStyle = css`
  &.Mui-focusVisible,
  &.Mui-selected {
    background-color: var(--bg-tertiary) !important;
  }
`;

export const iconButtonStyles = css`
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 0.4rem;

  ${svgSizeStyles(1.6)}
`;

export const headingItemStyles = css`
  &.MuiMenuItem-root:not(:first-child) {
    margin-top: 4px;
  }
`;

export const disableHoverStyles = css`
  &.MuiMenuItem-root:hover:hover {
    background-color: var(--bg-primary);
  }
  &.MuiButtonBase-root {
    cursor: default;
  }
`;

export const classes = {
  list: 'p-8 space-y-2 outline-none',
  listItem: cn(
    'h-64 p-12 flex items-center space-s-12 hover:bg-s-info-light rounded-8',
    menuItemSelectedStyle,
  ),
  headingListItem: cn(
    'h-40 p-12 flex items-center justify-between rounded-8',
    disableHoverStyles,
    headingItemStyles,
  ),
};

export const POPOVER_MAX_HEIGHT = 44;

export const mentionsPopperStyles = css`
  min-width: 36rem;
  max-width: 36rem;
  max-height: ${POPOVER_MAX_HEIGHT}rem;
  z-index: 1301; // modal has z-index 1300
`;

export const popperClassName = cn(
  mentionsPopperStyles,
  'shadow-01 rounded-8 my-8 border border-divider bg-bg-primary overflow-y-auto z-20',
);
